import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import { injectIntl } from 'react-intl';
import appConfig from '../../appConfig';
import UMOGalleryHeader from './UMOGalleryHeader';
import UMOGalleryHeaderInfo from './UMOGalleryHeaderInfo';
import UMOGridLayout from './UMOGridLayout';
import { toggleUMODetailView, toggleCompareView, toggleFullImageView } from '../../actions/mainUI';
import { retrieveUMOs, updatePageNumber } from '../../actions/umoGallery';
import { moveBetweenWorkspaces, moveUMO, addToWorkspace } from '../../actions/umo';
import { viewTypes } from '../../constants/umoGallery';
import { WorkspaceTag, SearchParams } from '../../utils/searchUtils';
import { addError } from '../../actions/messageDialog';
import { moveUmoHandler } from '../../utils/umoUtils';
import { CARD_VIEW_URL } from '../../constants/workspaceCards';
import HighlightsView from '../HighlightsView';

const mapStateToProps = state => ({
  umoGallery: state.umoGallery,
  session: state.session,
  mainUI: state.mainUI,
  workspacePreview: state.workspacePreview,
});

const mapDispatchToProps = dispatch => ({
  onPageChange: pageNumber => dispatch(updatePageNumber(pageNumber)),
  toggleUMODetailViewDispatch: umoID => dispatch(toggleUMODetailView(umoID)),
  dispatch: actionToDispatch => dispatch(actionToDispatch),
  retrieveUMOs: searchParams => dispatch(retrieveUMOs(searchParams)),
  moveUMO: (umoList, categoryID, searchParams, isCopy) =>
    dispatch(moveUMO(umoList, categoryID, searchParams, isCopy)),
  addToWorkspace: (workspaceID, umoList, searchParams, isCopy) =>
    dispatch(addToWorkspace(workspaceID, umoList, searchParams, { isCopy })),
  showErrorMessage: message => dispatch(addError(message)),
  moveBetweenWorkspaces: (fromWorkspaceID, toWorkspaceID, umoList, searchParams, isCopy) =>
    dispatch(moveBetweenWorkspaces(fromWorkspaceID, toWorkspaceID, umoList, searchParams, isCopy)),
  toggleCompareViewDispatch: selectedUMOIDs => dispatch(toggleCompareView(selectedUMOIDs)),
  toggleFullImageViewDispatch:
    (isShown, umoData) => dispatch(toggleFullImageView(isShown, umoData)),
});

class UMOGallery extends Component {
  constructor(props) {
    super(props);

    // is result set a workspace
    const isWorkspace = props.umoGallery.get('galleryType') === SearchParams.searchTypes.WORKSPACE;
    const tagList = props.umoGallery.getIn(['searchParams', 'tagList']);
    const tag =
      (tagList && tagList.length === 1 && isWorkspace && tagList[0] instanceof WorkspaceTag)
        ? tagList[0] : null;
    const title = (props.umoGallery.get('galleryType') === SearchParams.searchTypes.WORKSPACE ||
      props.umoGallery.get('galleryType') === SearchParams.searchTypes.CATEGORY) && tagList.length === 1 ?
      tagList[0].label : null;
    this.state = {
      mainTitle: title,
      mainDescription: tag ? tag.description : null,
      isWorkspace,
      workspaceID: tag ? tag.value : null,
      isMoving: false,
      cardViewTimes: null,
    };
    this.copyUMOs = this.copyUMOs.bind(this);
    this.categorySelectClick = this.categorySelectClick.bind(this);
    this.stopUmoCopy = this.stopUmoCopy.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.getCardViewTimes = this.getCardViewTimes.bind(this);
  }

  componentDidMount() {
    window.addEventListener('keydown', this.onKeyDown);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props !== prevProps) {
      const isWorkspace = this.props.umoGallery.get('galleryType') === SearchParams.searchTypes.WORKSPACE;
      const tagList = this.props.umoGallery.getIn(['searchParams', 'tagList']);
      const oldTagList = prevProps.umoGallery.getIn(['searchParams', 'tagList']);
      if (tagList !== oldTagList) {
        const tag =
          (tagList && tagList.length === 1 && isWorkspace && tagList[0] instanceof WorkspaceTag)
            ? tagList[0] : null;
        const title = (this.props.umoGallery.get('galleryType') === SearchParams.searchTypes.WORKSPACE ||
          this.props.umoGallery.get('galleryType') === SearchParams.searchTypes.CATEGORY) && tagList.length === 1 ?
          tagList[0].label : null;
        this.setState({
          mainTitle: title,
          mainDescription: tag ? tag.description : null,
          isWorkspace,
          workspaceID: tag ? tag.value : null,
        });
      }

      if (this.state.isWorkspace && this.state.workspaceID &&
        this.state.workspaceID !== prevState.workspaceID) {
        this.getCardViewTimes(this.state.workspaceID);
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.onKeyDown);
  }

  onKeyDown(e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      e.preventDefault();
      this.stopUmoCopy();
    }
  }

  /*
  * Returns A JSON Object/Array of umo_ids
  * that have cards and view times when
  * this usernm last view the card (may be null)
  * params catid, usernm
  * */
  getCardViewTimes(workspaceID) {
    const username = this.props.session.get('username').toUpperCase();
    $.get(
      CARD_VIEW_URL,
      { catid: workspaceID, usernm: username, SURL: this.props.session.get('surlCookie') ? null : this.props.session.get('surl') })
      .done((data) => {
        this.setState({ cardViewTimes: data });
      });
  }

  stopUmoCopy() {
    this.setState({ isMoving: false });
    $('.umo-gallery__copy-screen_overlay').css('visibility', 'hidden');
    $('.nav-options').removeAttr('style');
    $('.umo-gallery-header').removeAttr('style');
    $('.header__advSearch-button').prop('disabled', false);
    $('.search-simple').removeAttr('style');
    const catList = $('.panel-list');
    for (let i = 0; i < catList.length; i += 1) {
      catList[i].removeEventListener('click', this.categorySelectClick, false);
    }
    if (this.props.workspacePreview.get('selectedID')) {
      $('.workspace-preview')[0].removeEventListener('click', this.categorySelectClick, false);
    }
  }

  categorySelectClick(e) {
    e.stopPropagation();
    this.stopUmoCopy();
    const selectedUMOIDs = this.props.umoGallery.get('selectedUMOIDs');
    const isSelectAll = this.props.umoGallery.get('isSelectAll');
    const isTargetWorkspace = $('.nav-workspace').children($(e.target)).length > 0 ||
      e.target.classList.contains('workspace-preview') || $(`.workspace-preview #${e.target.id}`)[0];
    const origin = {
      id: this.state.workspaceID,
      isWorkspace: this.state.isWorkspace,
    };
    const target = {
      id: e.target.id || this.props.workspacePreview.get('selectedID'),
      isWorkspace: isTargetWorkspace,
      editable: e.target.dataset.editable !== 'false',
    };
    moveUmoHandler(origin, target, selectedUMOIDs, this.props.dispatch,
      isSelectAll ? this.props.umoGallery.get('searchParams') : null, true);
  }

  copyUMOs() {
    if (this.state.isMoving) {
      this.stopUmoCopy();
    } else {
      $('.search-simple').css('pointer-events', 'none');
      $('.header__advSearch-button').prop('disabled', true);
      $('.umo-gallery-header').css('pointer-events', 'none');
      $('.nav-options').css('pointer-events', 'none');
      $('.umo-gallery__copy-screen_overlay').css('visibility', 'visible');

      // set listeners for click on category list and pinned workspace elements
      const catList = $('.panel-list');
      for (let i = 0; i < catList.length; i += 1) {
        catList[i].addEventListener('click', this.categorySelectClick, false);
      }
      if (this.props.workspacePreview.get('selectedID')) {
        $('.workspace-preview')[0].addEventListener('click', this.categorySelectClick, false);
      }
      this.setState({ isMoving: true });
    }
  }

  render() {
    const {
      dispatch,
      umoGallery,
      onPageChange,
      toggleUMODetailViewDispatch,
      mainUI,
      workspacePreview,
      toggleCompareViewDispatch,
      intl,
    } = this.props;
    const searchParams = umoGallery.get('searchParams');
    return (
      <div className="main__umo-gallery">
        { mainUI.get('isHighlightsViewShown') ? <HighlightsView /> : null }
        <UMOGalleryHeader
          mainTitle={this.state.mainTitle}
          isUMOGalleryWorkspace={this.state.isWorkspace}
          sortBy={umoGallery.get('sortBy')}
          sortByIsDescending={umoGallery.get('sortByIsDescending')}
          dispatch={dispatch}
          umoGalleryViewType={mainUI.get('umoGalleryViewType')}
          searchParams={searchParams}
          selectedWorkspaceData={this.state.isWorkspace ? { id: this.state.workspaceID } : {
            id: workspacePreview.get('selectedID'),
            ...workspacePreview.get('selectedData').toJS(),
          }}
          selectedUMOIDs={umoGallery.get('selectedUMOIDs')}
          isSelectAll={umoGallery.get('isSelectAll')}
          copyUMOs={this.copyUMOs}
          umoList={umoGallery.get('umoList')}
          isSortMode={mainUI.get('gallerySortMode')}
          pageNumber={umoGallery.get('pageNumber')}
          pageTotal={umoGallery.get('pageTotal')}
          onPageChange={onPageChange}
          toggleCompareView={() => toggleCompareViewDispatch(umoGallery.get('selectedUMOIDs'))}
        />
        {!searchParams.isEmpty() ? // only display headers if a search was done
          <UMOGalleryHeaderInfo
            mainDescription={this.state.mainDescription}
            umoTotal={umoGallery.get('umoTotal')}
            isLoading={umoGallery.get('isRequesting')}
            isSortMode={mainUI.get('gallerySortMode')}
            selectedUMOIDs={umoGallery.get('selectedUMOIDs')}
            isSelectAll={umoGallery.get('isSelectAll')}
          />
          : null}
        <UMOGridLayout
          customMetatag={appConfig.customClassMetatag}
          umoRatings={appConfig.umoRatings}
          umoList={umoGallery.get('umoList')}
          searchParams={umoGallery.get('searchParams')}
          selectedUMOIDs={umoGallery.get('selectedUMOIDs')}
          isLoading={umoGallery.get('isRequesting')}
          isSelectAll={umoGallery.get('isSelectAll')}
          isUMOGalleryWorkspace={this.state.isWorkspace}
          dispatch={dispatch}
          onDetailViewClick={toggleUMODetailViewDispatch}
          isNotJustified={mainUI.get('umoGalleryViewType') === viewTypes.GRID_NOJ}
          selectedWorkspaceData={this.state.isWorkspace ?
            { id: this.state.workspaceID, label: this.state.mainTitle } : {
              id: workspacePreview.get('selectedID'),
              ...workspacePreview.get('selectedData').toJS(),
            }}
          highlightSetID={umoGallery.get('galleryType') === SearchParams.searchTypes.HIGHLIGHT ?
            umoGallery.get('searchParams').tagList[0].value : null}
          workspaceCardsViewTimes={this.state.cardViewTimes}
          viewType={mainUI.get('umoGalleryViewType')}
          isSortMode={mainUI.get('gallerySortMode')}
          galleryType={umoGallery.get('galleryType')}
          toggleFullImageView={this.props.toggleFullImageViewDispatch}
          retrieveUMOs={this.props.retrieveUMOs}
        />
        <div className="umo-gallery__copy-screen_overlay">
          <h2 className="umo-gallery__copy-screen_overlay__message">
            {intl.formatMessage({ id: 'searchResults.copy-screen_overlay__message' })}
          </h2>
          <h3 className="umo-gallery__copy-screen_overlay__cancel" >
            {intl.formatMessage({ id: 'searchResults.copy-screen_overlay__cancel' })}
          </h3>
        </div>
      </div>
    );
  }
}

UMOGallery.propTypes = {
  umoGallery: PropTypes.instanceOf(Map),
  session: PropTypes.instanceOf(Map),
  mainUI: PropTypes.instanceOf(Map),
  workspacePreview: PropTypes.instanceOf(Map),
  onPageChange: PropTypes.func,
  toggleUMODetailViewDispatch: PropTypes.func,
  dispatch: PropTypes.func,
  toggleCompareViewDispatch: PropTypes.func,
  toggleFullImageViewDispatch: PropTypes.func,
  retrieveUMOs: PropTypes.func,
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(UMOGallery));



// WEBPACK FOOTER //
// ./src/js/components/UMOGallery/index.jsx